import { Box, Button } from "@mui/material";
import Chart from "../icon/Chart";
import Menu from "../icon/Menu";
import { Dispatch, SetStateAction } from "react";
import { displayType } from "../../pages/eco-efficiency/add-data";

interface Props {
  type: displayType;
  setType: Dispatch<SetStateAction<displayType>>;
}

export const ChartAndTableButton = ({ type, setType }: Props) => {
  return (
    <Box display={"flex"} flexDirection={"row"}>
      <Button
        type="button"
        onClick={() => setType("chart")}
        sx={{
          borderRadius: "32px 0 0 32px",
          border: "1px solid var(--gray2)",
          padding: "8px 16px",
          color: type === "chart" ? "var(--white) !important" : "var(--gray1)",
          backgroundColor:
            type === "chart" ? "var(--green) !important" : "var(--white)",
          "&:hover": {
            backgroundColor: type === "chart" ? "var(--green)" : "var(--white)",
          },
        }}
      >
        <Chart />
      </Button>
      <Button
        type="button"
        onClick={() => setType("table")}
        sx={{
          borderRadius: "0 32px 32px 0",
          border: "1px solid var(--gray2)",
          padding: "8px 16px",
          color: type === "table" ? "var(--white) !important" : "var(--gray1)",
          backgroundColor:
            type === "table" ? "var(--green) !important" : "var(--white)",
          "&:hover": {
            backgroundColor: type === "table" ? "var(--green)" : "var(--white)",
          },
        }}
      >
        <Menu />
      </Button>
    </Box>
  );
};
